// AMOE 包私有 validators(D-02:本期不下沉 shared)

const AGE_RE = /^\d+$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * AMOE submit 后端字段长度上限。
 *
 * 这些值必须与 `AmoeController.validateSubmitReq` 保持一致，避免前端放过后端
 * 必然拒绝的提交。
 */
export const AMOE_SUBMIT_FIELD_MAX_LENGTH = {
  firstName: 100,
  lastName: 100,
  email: 255,
  countryCode: 10,
  phoneNumber: 50,
  addressLine1: 255,
  addressLine2: 255,
  city: 100,
  state: 50,
  zipCode: 20,
  smsCode: 10,
} as const;

export type AmoeSubmitLengthField = keyof typeof AMOE_SUBMIT_FIELD_MAX_LENGTH;

/**
 * 按后端 submit 入参长度口径做前置校验。
 *
 * 前端表单会先 trim 再提交，长度校验同样基于 trim 后的值；`addressLine2`
 * 为空时不参与必填校验，但只要有值就不能超过后端上限。
 */
export function isWithinSubmitMaxLength(
  field: AmoeSubmitLengthField,
  value: string,
): boolean {
  return value.trim().length <= AMOE_SUBMIT_FIELD_MAX_LENGTH[field];
}

/** D-05: 名字只做非空轻校验,具体合法性由 AMOE 后端与运营规则兜底。 */
export function isValidName(s: string): boolean {
  return typeof s === 'string' && s.trim().length > 0;
}

/** D-24: email 用简化格式校验,用于前端阻断明显错误输入。 */
export function isValidEmail(s: string): boolean {
  return typeof s === 'string' && EMAIL_RE.test(s.trim());
}

/** D-08: 非空 + 纯数字 + 整数 + >=18 */
export function isValidAge(s: string): boolean {
  const trimmed = s.trim();
  if (!AGE_RE.test(trimmed)) return false;
  const n = Number(trimmed);
  return Number.isInteger(n) && n >= 18;
}

/** D-30: 前端轻校,纯数字 + 长度 6-15;格式错误交给 SMS 平台回报 31025 */
export function isValidPhone(s: string): boolean {
  return /^\d{6,15}$/.test(s.trim());
}

/** D-28: 长度 ≥3 + 不含数字 + 仅 ASCII 可打印字符(32-126) */
export function isValidCity(s: string): boolean {
  const v = s.trim();
  return v.length >= 3 && !/\d/.test(v) && /^[\x20-\x7E]+$/.test(v);
}

/** US Zip:5 位 或 5+4 形式 */
export function isValidZip(s: string): boolean {
  return /^\d{5}(-\d{4})?$/.test(s.trim());
}

/** Sweepstakes 法规：Florida 居民不可参与 */
const BLOCKED_STATES: ReadonlySet<string> = new Set(['FL']);

export function isBlockedState(s: string): boolean {
  return BLOCKED_STATES.has(s.trim().toUpperCase());
}
